import React from 'react';
import { MdOutlineMail } from "react-icons/md";

const EmailInput = ({ email, handleEmailChange, handleEmailSubmit }) => {
  return (
    <form onSubmit={handleEmailSubmit} className="mb-4">
      <div className="relative mb-4 mt-4">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <MdOutlineMail className="text-gray-500" size="24px" />
        </span>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={handleEmailChange}
          className="border border-gray-300 rounded-lg py-2 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>
      <button
        type="submit"
        className="w-full bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-200"
      >
        Continue
      </button>

      {/* Horizontal line with "OR" */}
      <div className="flex items-center justify-center my-6 mb-1">
        <div className="border-t w-full border-gray-300"></div>
        <span className="mx-4 text-gray-500">OR</span>
        <div className="border-t w-full border-gray-300"></div>
      </div>
    </form>
  );
};

export default EmailInput;
